import React from 'react'
import { HeaderOnlyLayout } from '../../layouts'
import {
  KhubMap, SimplePageHeader, Footer, Container
} from '../../components'
import atf from '../../database/pages/atf.json'
import approaches from '../../database/meta/approaches.json'
// import { ChevronLeft } from 'react-feather'

// When integrate with backend, get this data from database
import regionDataWithoutZoom from '../../components/khub-map/data/region-dummy-data-no-zoom'
// import { useHistory } from 'react-router-dom'
import auth from '../../utils/auth'
import Select from 'react-select'
import { inputNormalizer, formUpdater } from '../../utils'
// import { Link } from 'react-router-dom'

const options = [
  {label: 'Organisasi', value: 0},
  {label: 'Kementrian Lembaga', value: 1},
  {label: 'Pemerintah Daerah', value: 2},
  {label: 'NGO', value: 3},
  {label: 'Swasta', value: 4},
  {label: 'Media', value: 5},
  {label: 'Donor', value: 6},
]

const optionsApproach = [{label: 'Approach', value: 0},...approaches.map((a,i) => {
  return {label: a.name, value: a.id}
})]

const MapHeader = () => {
  // const history = useHistory()
  const { isOfficial, isVerified } = auth()
  const [status, setStatus] = React.useState('idle')
  const [form, setForm] = React.useState({
    organisasi: '',
    approach: ''
  })

  const updateForm = (e) => formUpdater(e, form, setForm)

  const handleClear = () => {
    setStatus('clearing')
    setTimeout(() => {
      setStatus('idle')
    }, 100)
  }

  return (
    <Container className={`${isOfficial ? 'official' : isVerified ? 'verified' : ''} py-5`} color="#f5f5f5">
      <div className="flex flex-wrap justify-between items-center">
        {/* <div
          className="flex items-center cursor-pointer"
          onClick={() => history.push('/organization')}
        >
          <ChevronLeft style={{width: '16px'}} className="mr-4"/>
          <div className="text-xs lg:text-sm leading-none">Back to Organization List</div>
        </div> */}
        <div className="flex flex-wrap items-center ">
          <div className="lg:mr-10">
            <h3 className="uppercase text-lg lg:text-2xl mb-4 lg:mb-0">Filter</h3>
          </div>
          <div style={{minWidth: '255px'}} className="w-full lg:w-auto">
            {
              status === 'idle' &&
              <Select
                options={options}
                // multi
                noMarginBottom
                className="mb-2 lg:mb-0 mr-2 lg:mr-8 text-sm"
                placeholder="Organisasi"
                onChange={({value}) => inputNormalizer(value, 'organisasi', updateForm)}
              />
            }
          </div>
          <div style={{minWidth: '255px'}} className="w-full lg:w-auto">
            {
              status === 'idle' &&
              <Select
                placeholder="Approach"
                options={optionsApproach}
                noMargin
                className="mb-2 lg:mb-0 mr-2 lg:mr-8 text-sm"
                noMarginBottom
                onChange={({value}) => inputNormalizer(value, 'approach', updateForm)}
              />
            }
          </div>
        </div>
        <div
          className="underline text-sm ml-auto lg:ml-8 cursor-pointer"
          style={{minWidth: '94px', color: '#444'}}
          onClick={handleClear}
        >
          Clear all filters
        </div>
      </div>
    </Container>
  )
}

const RegionMap = () => {
  const mapData = regionDataWithoutZoom

  return (
    <HeaderOnlyLayout>
      <SimplePageHeader
        title="Map"
        description={atf.map}
        largePadding
      />
      {/* <div className="text-center py-5 link">
        <Link to="/region/detail">Link to region detail</Link>
      </div> */}
      <MapHeader />
      <KhubMap data={mapData} mapStyleColor="light"/>
      <Footer />
    </HeaderOnlyLayout>
  )
}

export { RegionMap }
